import { NonTimezoneSensitiveDate } from '@commenda/utils';
import { DateRange } from 'react-day-picker';

export const calculateDateRange = (period: string) => {
  let endDate = NonTimezoneSensitiveDate.fromNativeDate(new Date());
  let startDate = NonTimezoneSensitiveDate.fromNativeDate(new Date());

  switch (period) {
    case 'mtd':
      // Start of current month
      startDate = endDate.startOf('month');
      break;
    case 'pm':
      // Start of previous month
      startDate = endDate.subtract(1, 'month').startOf('month');
      // End of previous month
      endDate = endDate.subtract(1, 'month').endOf('month');
      break;
    case 'ytd':
      // Start of current year
      startDate = endDate.startOf('year');
      break;
    default: {
      const days = parseInt(period, 10);
      if (!Number.isNaN(days)) {
        startDate = endDate.subtract(days, 'days');
      }
      break;
    }
  }

  return {
    from_date: startDate.toISO8601String(),
    to_date: endDate.toISO8601String(),
  };
};

export const formatDateRange = (range: {
  from_date: string;
  to_date: string;
}): string => {
  const formatDate = (dateString: string) => {
    if (!dateString) return '';
    const date = NonTimezoneSensitiveDate.fromISO8601String(dateString);
    return date.format('MMM DD, YYYY');
  };

  return `${formatDate(range.from_date)} - ${formatDate(range.to_date)}`;
};

export const formatDateRangeFromDate = (range: DateRange) => {
  const formatDate = (date: Date) => {
    if (!date) return '';
    const dateISO =
      NonTimezoneSensitiveDate.fromNativeDate(date).toISO8601String();
    const dateFormatted = NonTimezoneSensitiveDate.fromISO8601String(dateISO);
    return dateFormatted.format('MMM DD, YYYY');
  };

  return `${formatDate(range.from)} - ${formatDate(range.to)}`;
};
